<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full-width" no-footer-line>
                <div
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <h4 class="card-title text-purple">
                        {{ $t("app.modules.web_notifications.title") }}
                    </h4>
                    <fg-input>
                    <el-input
                        type="search"
                        class="mb-3"
                        clearable
                        prefix-icon="el-icon-search "
                        style="width: 300px"
                        :placeholder="$t('app.general.search')"
                        v-model="searchQuery"
                        aria-controls="datatables"
                    >
                    </el-input>
                    </fg-input>
                </div>
                <div class="row col-12">
                    <div 
                        class="col-md-12" 
                        v-for="item in queriedData" 
                        :key="item.idHistorial" 
                    >
                        <a :href="item.enlace" style="color:black;" @click="read(item.idHistorial)">
                            <card>
                                <div class="col-12">{{ item.fecha }}</div>
                                <div class="row">
                                <div class="col-10">{{ item.contenido }}</div>
                                <div class="col-2 text-right">
                                    <template v-if="item.leida">
                                        <i class="now-ui-icons ui-1_check"></i>
                                    </template>
                                </div>
                                </div>
                            </card>
                        </a>
                    </div>
                </div>
                 <div
                    slot="footer"
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                    <div class="">
                        <p class="card-category">
                        {{ $t("app.pagination.showing") }} {{ from + 1 }}
                        {{ $t("app.pagination.of") }} {{ to }}
                        {{ $t("app.pagination.of") }} {{ total }}
                        {{ $t("app.pagination.records") }}
                        </p>
                    </div>

                    <n-pagination
                        class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </n-pagination>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    components: {}, 
    computed: {
        queriedData(){
            let result = this.tableData;

            // Search by term 
            result =
            this.searchQuery.length > 0
                ? result.filter(p => p.contenido.toLowerCase().includes(this.searchQuery.toLowerCase()))
                : result;

            return result.slice(this.from, this.to);
        }, 
        to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
            highBound = this.total;
        }
        return highBound;
        },
        from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
        return this.searchedData.length > 0
            ? this.searchedData.length
            : this.tableData.length;
        }
    }, 
    data() {
        return{
            searchQuery: "",
            tableData: [], 
            searchedData: [], 
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            }
        }
    }, 
    async mounted() {
        this.init();
    }, 
    methods: {
        async init() {
            this.$swal.fire({
                title: this.$t("app.promps.wait"),
                html:
                '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                showConfirmButton: false
            });
            await this.getItems();
            this.$swal.close();
        },
        async getItems(){
            const params = {
                Id: this.$store.state.user.idUsuario, 
                ClaveIdioma: this.$store.state.lang, 
                Usuario: 0
            };

            await this.$http
            .post(route("NotificacionWeb/getNotificacionesWebHistorial"), params)
            .then(
            response => {
                if (response.body.code === 200) {
                this.tableData = response.body.historial.sort((a, b) => (a.idHistorial < b.idHistorial) ? 1 : -1);
                } else {
                    console.log(response.body);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            },
            error => {
                console.error(error);
                this.notifyMessage("danger", this.$t("app.promps.error"));
            }
            );
        }, 
        async read(id){
            const params = {
                Id: id, 
                ClaveIdioma: this.$store.state.lang, 
                Usuario: 0
            };

            await this.$http
                .post(route("NotificacionWeb/postNotificacionLeida"), params)
                .then(
                response => {
                    if (response.body.code === 200) {
                        this.getNotCount();
                    } else {
                        console.log(response.body);
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    console.error(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            );
        }, 
        async getNotCount(){
            const params = {
                Id: this.$store.state.user.idUsuario, 
                ClaveIdioma: this.$store.state.lang, 
                Usuario: 0
            };

            await this.$http
                .post(route("NotificacionWeb/getNotificacionesWebConteo"), params)
                .then(
                response => {
                    if (response.body.code === 200) {
                        this.$store.state.not_count = response.body.Id
                    } else {
                        console.log(response.body);
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    console.error(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            );
        }
    } 
}
</script>